export const VerificationStatus = {
	PENDING: 0,
	PROCESSING: 1,
	COMPLETED: 2,
}
